import React from 'react';

const Gas = props => (
  <svg
    width={25}
    height={32}
    viewBox="0 0 25 32"
    preserveAspectRatio="xMidYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M10.353 17.44c.928.584 1.775 1.758 1.775 2.962 0 .987-.411 1.983-1.065 2.591-.544-.507-.955-1.433-1.067-2.223-1.775.864-2.84 2.835-2.84 4.817 0 2.862 2.228 5.186 4.974 5.186 2.75 0 4.976-2.322 4.976-5.186 0-4.004-3.017-7.497-6.752-8.148h-.001Z"
      stroke="#FAFAFA"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M8.604 1c2.087 1.318 3.998 3.961 3.998 6.668 0 2.218-.928 4.462-2.4 5.833-1.221-1.144-2.147-3.226-2.398-5.001-3.993 1.94-6.397 6.374-6.397 10.834C1.407 25.78 6.421 31 12.601 31c6.183 0 11.194-5.221 11.194-11.666 0-9.011-6.791-16.87-15.191-18.334Z"
      stroke="#FAFAFA"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Gas;
